module.exports = "<div class=\"center-project-images\">\n<i class=\"icon\" ><img data-ng-src=\"data:image/png;base64,{{row.entity.dbTypeImage}}\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/projects/projects-list/templates/projectIcon.tpl.html
// module id = 1822
// module chunks = 0